export interface ContractsGraphPoint {
  name: string;
  value: number;
  place: number;
  x?: number;
}

export interface ContractsGraphData {
  data: ContractsGraphPoint[];
  maxValue: number;
  ticks?: number[];
}

export const buildContractsGraphData = (
  points: Array<{ name: string; value: number }>,
  options?: { paddingEnds?: 'wide' | 'narrow' | false },
): ContractsGraphData => {
  if (!points?.length) return { data: [], maxValue: 0 };

  const paddingEnds = options?.paddingEnds ?? 'wide';
  const maxValue = Math.max(1.5 * Math.max(...points.map(p => p.value)), 5);

  const realPoints: ContractsGraphPoint[] = points.map(p => ({
    name: p.name,
    value: p.value,
    place: maxValue - p.value,
  }));

  if (paddingEnds === 'wide') {
    const data: ContractsGraphPoint[] = [
      { name: '', value: 0, place: maxValue },
      ...realPoints,
      { name: '', value: 0, place: maxValue / 2 },
    ];
    return { data, maxValue };
  }

  if (paddingEnds === 'narrow') {
    const data: ContractsGraphPoint[] = [
      { x: 0, name: '', value: 0, place: maxValue },
      ...realPoints.map((p, i) => ({ ...p, x: i + 0.5 })),
      { x: realPoints.length, name: '', value: 0, place: maxValue / 2 },
    ];
    const ticks = realPoints.map((_, i) => i + 0.5);
    return { data, maxValue, ticks };
  }

  return { data: realPoints, maxValue };
};
